import type { OrderFormInfoData } from '@/types/RequisitionFormTypes'

/**
 * `caller` string for IMDB-backed order reads/writes once the order's form data
 * is loaded. Uses the ordering provider's name, falling back to a stable
 * sentinel so audit rows always have a non-empty origin.
 */
export function getCallerFromOrderData(orderData?: OrderFormInfoData): string {
  const first = orderData?.orderingProvider?.name?.firstName ?? ''
  const last = orderData?.orderingProvider?.name?.lastName ?? ''
  const name = `${first} ${last}`.trim()
  return name || 'spa'
}

/**
 * `caller` string for the initial order fetch, before form data is available.
 * Epic launches derive the name from the launch context; standalone (Auth0)
 * launches use the authenticated user's email/sub. Each branch falls back to a
 * stable sentinel so the audit origin is never empty.
 */
export function resolveOrderFetchCaller(
  epicContext: { userName?: string | null; userLastName?: string | null } | null | undefined,
  user: { email?: string | null; sub?: string | null } | null | undefined
): string {
  if (epicContext) {
    return `${epicContext.userName || ''} ${epicContext.userLastName || ''}`.trim() || 'epic-user'
  }
  return user?.email || user?.sub || 'standalone-user'
}
